import { createSlice } from "@reduxjs/toolkit";

const eraser=createSlice({
	name:"eraser",
	initialState:{e:0},
	reducers:{
		setEraserS:(state,action)=>{state.e=action.payload}
	}
});

export const {setEraserS}=eraser.actions
export default eraser.reducer